import * as React from "react";

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.81 53.81" {...props}>
    <path fill="#FCD502" d="M7.99 36.52 26.91 8.14l18.92 28.38H7.99z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M45.83 36.52 26.91 8.14 7.99 36.52h37.84z"
    />
    <path
      fill={"currentColor"}
      d="M26.91 32.59a1.48 1.48 0 0 1-1.05-.43 1.44 1.44 0 0 1-.44-1 1.48 1.48 0 0 1 2.58-1.1 1.49 1.49 0 0 1 .44 1.05 1.5 1.5 0 0 1-1.49 1.48zm-.41-4.52a.5.5 0 0 1-.5-.46c-.15-1.79-.33-3.65-.55-5.53s-.33-3.07-.33-3.43a1.88 1.88 0 0 1 .5-1.31 1.79 1.79 0 0 1 2.58 0 1.88 1.88 0 0 1 .49 1.31c0 .36-.11 1.48-.33 3.43s-.42 3.75-.58 5.54a.51.51 0 0 1-.5.45z"
    />
  </svg>
);

export default SvgComponent;
